import React, { useEffect } from 'react'
import BEMHelper from '@ynap/bem-helper'
import { reduxForm } from 'redux-form'
import Field from '@ynap/field'
import Checkbox from '@ynap/checkbox'
import { dispatch as trackEvent } from '@ynap/analytics'
import validate from './validate'

import { trackDDUAccepted, trackDDUError, trackDDUDisplayed } from './analytics'

const bem = new BEMHelper('DDUAcceptanceForm')

export const DDUAcceptanceForm = ({ messages, checkoutAnalytics, className, valid, getCheckboxValue = null }) => {
    useEffect(() => {
        trackEvent(trackDDUDisplayed(checkoutAnalytics))
    }, [])

    useEffect(() => {
        getCheckboxValue && getCheckboxValue(valid)
    }, [valid])

    return (
        <Field
            className={bem('checkbox', null, className)}
            component={Checkbox}
            name="acceptAdditionalCosts"
            format={(value) => value === 'true'}
            normalize={(value) => value.toString()}
            errorStyle={'outlineError'}
            notificationType={'field-error'}
        >
            {messages.addressForm.acceptAdditionalCosts()}
        </Field>
    )
}

export const formName = 'dduAcceptance'

export default reduxForm({
    form: formName,
    validate,
    onChange: ({ acceptAdditionalCosts, checkoutAnalytics }) => {
        if (acceptAdditionalCosts === 'true') {
            trackEvent(trackDDUAccepted(checkoutAnalytics))
        }
    },
    onSubmitFail: ({ checkoutAnalytics }) => {
        trackEvent(trackDDUError(checkoutAnalytics))
    },
    onSubmit: () => {},
    destroyOnUnmount: false,
})(DDUAcceptanceForm)
